// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { fontWeight } from '@mui/system';

const useStyles = (theme: any) => ({
  sidebarContent: {
    flex: 1,
    overflow: 'auto',
    width: theme.sidebarWidth - 70,
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'column',
  },
  filesSidebar: {
    marginTop: theme.spacing(2),
    overflowY: 'auto',
  },
  mainContent: {
    display: 'flex',
    height: '100%',
  },
  header: {
    marginLeft: '10px',
    fontWeight: 600,
  },
  sidebarTitle: {
    display: 'none',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  expansionPanelHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    margin: 0,
  },
  wrapper: {
    paddingBottom: theme.spacing(1),
    backgroundColor: 'rgba(248, 248, 248, 1)',
  },
  file: {
    marginTop: '5px',
  },
  fileItalic: {
    marginTop: '5px',
    width: '100%',
    height: '40px',
    fontFamily: 'Work Sans',
    fontWeight: 400,
    fontStyle: 'italic',
    fontSize: '14px',
    lineHeight: '100%',
    letterSpacing: '0.6px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'rgba(28, 54, 75, 0.6)',
    backgroundColor: 'rgba(248, 248, 248, 1)',
  },
  fileItalics: {
    marginTop: '5px',
    width: '100%',
    height: '40px',
    fontFamily: 'Work Sans',
    fontWeight: 400,
    fontStyle: 'italic',
    fontSize: '14px',
    lineHeight: '100%',
    letterSpacing: '0.6px',
    display: 'none',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'rgba(28, 54, 75, 0.6)',
    backgroundColor: 'rgba(248, 248, 248, 1)',
  },
  button: {
    padding: '6px',
  },
  sliderbtn: {
    marginLeft: 'auto',
    marginRight: '8px',
    padding: '6px', // Better click target
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  lasFileListItem: {
    paddingTop: '0px',
    paddingBottom: '0px',
    paddingRight: '12px',
    width: '100%',
    gap: '10%',
    justifyContent: 'space-between',
    backgroundColor: 'rgba(248, 248, 248, 1)',
  },
  lasfile: {
    fontWeight: 400,
    color: '#021E40',
    padding: '8px 0 4px 18px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  pointCloudSelection: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  lasfileContainer: {
    marginLeft: theme.spacing(1),
  },
  layerName: {
    color: '#021E40',
  },
  layerNamePc: {
    color: '#021E40',
    marginLeft: theme.spacing(2),
  },
  layers: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(1),
  },
  sidebarContainer: {
    position: 'relative',
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  togglesidebarsvg: {
    fontSize: 24,
  },
  cadcursor: {
    cursor: 'pointer',
  },
  layerbox: {
    mt: 0,
  },
  adjustpannelicon: {
    width: '20px',
    height: '20px',
  },
  unclassadjustpannelicon: {
    width: '20px',
    height: '20px',
  },
  mastertogglesx: {
    mb: 2,
  },
  laslegendtitle: {
    pl: 4,
    pt: 1,
  },
  lasclassid: {
    display: 'flex',
    alignItems: 'center',
    mb: 0.5,
  },
  lascolor: {
    width: 12,
    height: 12,
    borderRadius: '50%',
    mr: 1,
  },
  unknowoutline: {
    border: '1px solid rgba(128, 128, 128, 1)',
    boxSizing: 'border-box',
  },
  lasnametypo: {
    flex: 1,
    color: theme.palette.text.primary,
  },
  eyetoggleopac: {
    opacity: 0.6,
    padding: '8px 0 0 35px',
  },
  eyetogglelegend: {
    opacity: 0.6,
  },
  checkboxpc: {
    padding: theme.spacing(0),
    left: 9,
  },
  orderchangebox: {
    px: 2,
    py: 1,
  },
  cadbox: {
    mb: 0,
  },
  mastertogglebox: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
  },
  maxshowbox: {
    width: '100%',
    textAlign: 'center',
    mt: 0.5,
  },
  viewclass: {
    color: 'primary.main',
    fontWeight: 600,
    cursor: 'pointer',
    textDecoration: 'underline',
    '&:hover': { opacity: 0.8 },
  },
  unclassifiedbox: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
  },
  orderSelect: {
    '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
    '&:hover .MuiOutlinedInput-notchedOutline': { border: 'none' },
    '& .MuiSelect-select': {
      py: 0.5,
      pl: 0,
      pr: 3,
      fontWeight: 600,
      color: '#788898',
      backgroundColor: 'transparent',
      '&:focus': { backgroundColor: 'transparent' },
    },
    '& .MuiSelect-icon': {
      left: 80,
      color: theme.palette.text.secondary,
    },
  },
  pinButton: {
    position: 'absolute',
    top: 8,
    right: 6,
    zIndex: 10,
    backgroundColor: theme.palette.action.hover,
    borderRadius: '50%',
    padding: 0.5,
    '&:hover': {
      backgroundColor: theme.palette.action.selected,
    },
  },
  sidebarWrapper: (isSidebarVisible: boolean) => ({
    ...{
      display: isSidebarVisible ? 'flex' : 'none',
      width: isSidebarVisible ? theme.sidebarWidth - 70 : 0,
      transition: 'width 0.3s ease',
    },
  }),
  errorIconSpace: {
    width: '16px',
    minWidth: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  errorIconContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  errorIcon: {
    fontSize: 'small',
  },
  errorTooltip: {
    position: 'absolute',
    bottom: '100%',
    left: '0',
    mb: 1,
    bgcolor: '#fff',
    color: '#021E40',
    fontSize: '13px',
    minWidth: 245,
    maxWidth: 350,
    padding: '8px 12px',
    borderRadius: 1,
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    zIndex: 1000,
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    border: '1px solid #e0e0e0',
  },
  errorTooltipText: {
    fontSize: '13px',
    color: 'inherit',
  },
  classifiederror: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    padding: '8px 16px',
  },
  classifiedsvg: {
    color: '#FF0000',
    flexShrink: 0,
  },
  noorderbox: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    padding: '6px 0px',
  },
  noordertypo: {
    fontSize: '14px',
    color: '#788898',
    fontWeight: 500,
  },
  classifiedErrorText: {
    fontFamily: 'Work Sans',
    fontWeight: 400,
    fontStyle: 'italic',
    fontSize: '14px',
    lineHeight: '140%',
    color: 'rgba(28, 54, 75, 0.8)',
    marginLeft: theme.spacing(1),
  },
  generrormessage: {
    color: '#01A1DD',
    cursor: 'pointer',
    '&:hover': { textDecoration: 'underline' },
  },
  layerListContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    padding: '8px 0',
    zIndex: 1000,
  },

  layerItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '4px 8px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },

  layerColorBox: {
    width: '16px',
    height: '16px',
    borderRadius: '2px',
    border: '1px solid rgba(0, 0, 0, 0.1)',
    flexShrink: 0,
  },

  layerNameText: {
    flex: 1,
    fontSize: '14px',
    color: '#021E40',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  ongroundfilechange: {
    fontSize: '0.875rem',
    ml: 2,
    mb: 1,
    maxWidth: 'calc(100% - 100px)',
    '& .MuiSelect-select': {
      paddingLeft: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
  onaerialfilechange: {
    fontSize: '0.875rem',
    ml: 2,
    mb: 1,
    maxWidth: 'calc(100% - 100px)',
    '& .MuiSelect-select': {
      paddingLeft: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
  colorui: {
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    marginRight: '8px',
    flexShrink: 0,
  },
  popover: {
    '& .MuiPopover-paper': {
      maxWidth: '250px',
      padding: '8px 12px',
      backgroundColor: '#fff',
      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    },
  },
});

export default useStyles;
